import FSCss from "../../css/overview.module.css";
import React, { useState } from "react";
import { useHistory } from "react-router-dom";
import { ReactComponent as DeleteIcon } from "../../../myfin_v2/assets/icons/delete_icon_primary.svg";
import { ReactComponent as SearchIcon } from "../../../myfin_v2/assets/icons/searchPri.svg";
import buttoncss from "../../../myfin_v2/css/button.module.css";
import { Button } from "../../../myfin_v2/elements/Button";
import NoteSoftDelete from "../../../Components/templateTabs/NoteSoftDelete/softDelete";
import RestoreSoftDelete from "../../../Components/templateTabs/NoteSoftDelete/restoreSoftDelete";
import Breadcrumb from "../Breadcrumb";

const PopulateFSTopBar = ({
  history,
  consolID,
  prepopulate = false,
  workspaceName = "Workspace",
  consolName = "Consol",
  activeCat = "BS",
  workspaceID = "",
}) => {
  const categoryLabels = {
    "BS": "Balance Sheet",
    "PL": "P&L Statement",
    "general notes": "General Notes",
    "cashflow": "CashFlow",
    "socie": "SOCIE",
    "BS notes": "Balance Sheet Notes",
    "PL notes": "P&L Statement Notes",
    "disclosure": "Disclosures",
    "checklist": "Disclosures Checklist"
  };

  const breadcrumbItems = [
    {
      label: workspaceName,
      link: workspaceID ? `/consolidation/${workspaceID}` : `/myfinV2/standalonefs`,
      className: "headerLable clickable",
    },
    {
      label: consolName,
      link: `/myfinV2/console-prepopulatefs/${consolID}`,
      className: "headerLable clickable",
    },
    {
      label: `Consol FS - ${categoryLabels[activeCat] || activeCat}`,
      link: "",
      className: "headerLable",
    },
  ];

  return (
    <div className={FSCss.w100}>
      <div className={FSCss.uploadLoansMainContainer}></div>

      <div className={FSCss.listPageheader} style={{ padding: "10px 20px" }}>
        <div className={FSCss.headerLeftContainer} style={{ width: "auto", display: "flex", alignItems: "center" }}>
          <Breadcrumb
            addCls="bgTransprent"
            p0={true}
            items={breadcrumbItems}
            headerActions={<></>}
          />
        </div>
        <div className={FSCss.headerRightContainer}>         
          &ensp;
          {prepopulate ? (
            <Button
              btnColor={buttoncss.primary}
              label="Populate FS"
              onClick={() => {
                history.push(`/myfinV2/console-populatefs/${consolID}`);
              }}
            />
          ) : (
            <Button
              btnColor={buttoncss.primary}
              label="Finalise FS"
              onClick={() => {
                history.push(`/consol/finalize-fs/${consolID}`);
              }}
            />
          )}
        </div>
      </div>
    </div>
  );
};

export default PopulateFSTopBar;
